import { makeStyles, Theme } from "@material-ui/core"

export default makeStyles((theme: Theme) => ({
  root: {
    width: `100vw`,
    maxWidth: 500,
    padding: theme.spacing(2),
  },
}))
